import { makeStyles, Text, Title2, Title3 } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { dolphinTokens } from "../../../utils/Theme";
import Title from "../../../administration/Title";

const useStyles = makeStyles({
    section: {
        padding: "1rem 0",
        textAlign: "center"
    },
    title: {
        fontSize: "2rem",
        marginBottom: "2rem",
        lineHeight: 1,
        "text-align": "center !important",

        "& .highlight": {
            color: dolphinTokens.colorLightBlue
        }
    },
    cards: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "2rem",
        maxWidth: "1200px",
        margin: "0 auto",

        "@media (max-width: 992px)": {
            flexDirection: "column"
        }
    },
    card: {
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "1.5rem",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        textAlign: "left",
        width: "300px",
        
        "@media (max-width: 992px)": {
            width: "100%",
            maxWidth: "300px"
        }
    },
    cardTitle: {
        fontSize: "1.2rem",
        marginBottom: "1rem",
        color: "#333"
    },
    cardText: {
        fontSize: "0.9rem",
        color: "#666"
    },
    cardLeft: {
        borderTop: `4px solid ${dolphinTokens.colorLightBlue}`,
    },
    cardRight: {
        borderTop: `4px solid ${dolphinTokens.colorLightBlue}`,
    },
    cardTop: {
        borderTop: `4px solid ${dolphinTokens.colorDarkBlue}`,
    },
    cardBottom: {
        borderTop: `4px solid ${dolphinTokens.colorDarkBlue}`,
    },
    centreCards: {
        display: "flex",
        flexDirection: "column",
        gap: "2rem"
    }
});

const Card = (props: { title: string, content: string, classNames?: string }) => {
    const { title, content, classNames } = props;
    const styles = useStyles();

    return (
        <div className={`${styles.card} ${classNames}`}>
            <Title3 as="h3" className={styles.cardTitle}>{title}</Title3>
            <Text block as="p" className={styles.cardText}>{content}</Text>
        </div>  
    );
};

export default function Separation() {
    const { t } = useTranslation("ourstory");
    const styles = useStyles();

    return (
        <section className={styles.section}>
            <Title2 block as="h2" className={styles.title}>
                <span dangerouslySetInnerHTML={{ __html: t("separation.title") }} />
            </Title2>
            
            <div className={styles.cards}>
                
                <Card
                    title={t("separation.cards.aim.title")}
                    content={t("separation.cards.aim.content")}
                    classNames={styles.cardLeft}
                    />

                <div className={styles.centreCards}>
                    <Card
                        title={t("separation.cards.approach.title")}
                        content={t("separation.cards.approach.content")}
                        classNames={styles.cardTop}
                        />
                    <Card
                        title={t("separation.cards.focus.title")}
                        content={t("separation.cards.focus.content")}
                        classNames={styles.cardBottom}
                        />
                </div>

                <Card
                    title={t("separation.cards.solutions.title")}
                    content={t("separation.cards.solutions.content")}
                    classNames={styles.cardRight}
                    />
            </div>
        </section>
    );
}